import {modalHtmlInit} from '../../modules/modal';
import {trackArticleShareEvent} from '../track-shares';

import '../../modules/modal/modal.css';

const WHATSAPP = 'whatsapp';
const FACEBOOK = 'facebook';
const TELEGRAM = 'telegram';
const VK = 'vkontakte';
const TWITTER = 'twitter';
const X = 'x';
const UTM_MEDIUM = 'article-share-bottom-nav-menu';

const LIST_SHARE_NETWORKS = [
  {
    type: WHATSAPP,
    name: 'Whatsapp',
    icon: WHATSAPP,
    baseUrl: 'whatsapp://send'
  },
  {
    type: FACEBOOK,
    name: 'Facebook',
    icon: FACEBOOK,
    baseUrl: 'https://www.facebook.com/sharer/sharer.php'
  },
  {
    type: TELEGRAM,
    name: 'Telegram',
    icon: TELEGRAM,
    baseUrl: 'https://t.me/share/url'
  },
  {
    type: VK,
    name: 'ВКонтакте',
    icon: VK,
    baseUrl: 'https://vk.com/share.php'
  },
  {
    type: TWITTER,
    name: 'X (Twitter)',
    icon: X,
    baseUrl: 'https://twitter.com/share'
  }
];

const styles = {
  text: `
    cursor: pointer;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    margin-left: 15px;
    color: #212121;`,
  wrapper: `
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 10px;`
};

export const getIconUrl = pathName => `/${__STATIC_DIRECTORY__}/img/${pathName}.svg`;

const getArticleUrlWithUtm = utmMedium => (source, articleUrl) => (
  encodeURI(`${articleUrl}?utm_medium=${utmMedium}&utm_source=${source}`)
);

export const getShareUrl = ({articleUrl, title, type, baseUrl, utmMedium}) => {
  const encodedTitle = encodeURI(title);
  const encodedArticleUrl = getArticleUrlWithUtm(utmMedium)(type, articleUrl);

  switch (type) {
    case WHATSAPP:
      return `${baseUrl}?text=${encodedTitle} ${encodedArticleUrl}`;
    case FACEBOOK:
      return `${baseUrl}?u=${encodedArticleUrl}`;
    case TELEGRAM:
    case TWITTER:
      return `${baseUrl}?url=${encodedArticleUrl}&text=${encodedTitle}`;
    case VK:
      return `${baseUrl}?url=${encodedArticleUrl}`;
    default:
      return '';
  }
};

const renderListHtml = ({list, articleUrl, articleTitle, utmMedium}) => list.map(({type, icon, name, baseUrl}) => {
  const shareUrl = getShareUrl({
    type,
    articleUrl,
    title: articleTitle,
    baseUrl,
    utmMedium
  });

  return (`
    <a
      href="${shareUrl}"
      rel="nofollow noopener"
      target="_blank"
      style="${styles.wrapper}"
      class="modal__share-button modal__share-button--${type}"
      data-platform="${type}"
    >
      <img alt="${type} logo" src="${getIconUrl(`social-icons/new/${icon}`)}" width="35" height="35">
      <p style="${styles.text}">${name}</p>
    </a>
  `);
});

const handleShare = (articleId, articleUrl) => {
  const $buttonCopyLink = document.querySelector('.js-modal-copy-link');

  $buttonCopyLink?.addEventListener('click', () => {
    import(/* webpackChunkName: "copy-to-clipboard" */ './copy-to-clipboard').then(module => {
      module.default(articleUrl, $buttonCopyLink);
    });
  });

  const shareModalWrapper = document.querySelector('.share-modal__content');
  const handleShareButtonClick = e => {
    const shareButton = e.target.closest('.modal__share-button');

    if (shareButton) {
      trackArticleShareEvent(articleId, articleUrl, shareButton.dataset.platform);
    }
  };

  if (shareModalWrapper) {
    shareModalWrapper.addEventListener('click', handleShareButtonClick);
  }
};

export default (articleUrl, articleTitle, articleId, isWhatsapp = true, utmMedium = UTM_MEDIUM) => {
  const newList = isWhatsapp
    ? LIST_SHARE_NETWORKS
    : LIST_SHARE_NETWORKS.filter(({type}) => type !== WHATSAPP);

  modalHtmlInit({
    dataClass: 'modal__data-container--center',
    isBodyBlured: false,
    callback: () => handleShare(articleId, articleUrl),
    renderHeader: () => '',
    html: `<div class="modal__content share-modal__content" style="min-width: 328px; min-height: 340px;">
      <header class="modal-header--center">
        <h2 class="modal__header-text modal__header-text--medium">Поделиться</h2>
        <div class="modal__close modal__close--medium"></div>
      </header>
      <div style="margin-top: 20px;">
        <div class="js-modal-copy-link modal__share-button" style="${styles.wrapper}" data-platform="copy">
          <img alt="icon for copy link" src="${getIconUrl('social-icons/new/copy-link')}" width="35" height="35">
          <p style="${styles.text}">Копировать ссылку</p>
        </div>
        ${renderListHtml({list: newList, articleUrl, articleTitle, utmMedium}).join('')}
      </div>
    </div>`
  })
    .show();
};
